import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  const saved = localStorage.getItem('resume-lang');
  if (saved === 'en' || saved === 'he') return saved;
  const browserLang = (navigator.language || '').toLowerCase();
  return browserLang.startsWith('he') ? 'he' : 'en';
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLanguage);

  useEffect(() => {
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', lang === 'he' ? 'rtl' : 'ltr');
    localStorage.setItem('resume-lang', lang);
  }, [lang]);

  const toggleLanguage = () => {
    setLang((prev) => (prev === 'en' ? 'he' : 'en'));
  };

  const isRTL = lang === 'he';

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};
